import React, { useContext, useEffect, useState } from 'react';
import { StyledCardContainer, StyledCardWrapper, StyledCardInfoColumn, StyledPlayerNumber, StyledEditImage, StyledRemoveImage, StyledCloseImage, StyledRibbon, StyledPlayerImage, StyledButtonWrapper, StyledCardImage } from './TableCard.styled';
import Button from '../../Button/Button';
import Profiel1 from "../../../assets/images/profile1.png"
import EditIcon from "../../../assets/images/edit.png"
import SubmitIcon from "../../../assets/images/submit.png"
import CloseIcon from "../../../assets/images/close.png"
import RemoveIcon from "../../../assets/images/remove.png"
import { SocketEmit, SocketOn, TableData } from '../../../types.ds';
import { game } from '../../../store/game';
import { PlayerContext } from '../../../contexts/playerContext';
import { toastSettings } from '../../App/App.styled';
import { toast } from 'react-toastify';
import { getUserInfo } from '../../../utils/getUserInfo';
import Input from '../../Input/Input';
import { updateTableInfo } from '../../../utils/updateTableInfo';
import { socket } from '../../../server/socket';

interface Props {
    table: TableData
    style: string
    setActive: (active: string) => void
}

const TableCard = (props: Props) => {
    const playerContext = useContext(PlayerContext);
    const [editTable, setEditTable] = useState(false);
    const [updateTableName, setUpdateTableName] = useState<string>(props.table.table_name);

    const onJoinTable = (name: string, address: string, balance: number, id: string) => {
        if (playerContext?.playerId == undefined) {
            toast('Link your wallet.', toastSettings);
            return;
        }
        game.emit[SocketEmit.JoinTable](id, playerContext.playerId, name, address, balance, playerContext?.avatar)
    };
    const handleJoinTable = async () => {
        if (playerContext?.tokenBalance != undefined && playerContext?.tokenBalance <= 0) {
            props.setActive("active");
            return;
        }
        const user = await getUserInfo(playerContext?.anchorWallet?.publicKey.toString());
        if (user && user.userData?.blocked) {
            toast('You are blocked', toastSettings);
            return;
        }
        if (playerContext?.tokenBalance && playerContext.wallet.publicKey) {
            onJoinTable(
                playerContext.playerName,
                playerContext.wallet.publicKey?.toString(),
                playerContext?.tokenBalance,
                props.table.table_id
            );
        }
    }

    const handleEditTable = () => {
        if (!editTable) {
            setUpdateTableName(props.table.table_name);
        } else {
            game.emit[SocketEmit.UpdateTable](props.table.table_id, updateTableName);
        }
        game.emit[SocketEmit.GetTables]();
        setEditTable(!editTable);
    }

    const handleRemoveTable = async () => {
        game.emit[SocketEmit.RemoveTable](props.table.table_id)
    }

    const handleCloseEditTable = () => {
        setEditTable(false);
    }

    const handleSetTableName = (e: any) => {
        setUpdateTableName(e.target.value);
    }

    useEffect(() => {
        const handleTableUpdated = async (data: string) => {
            const table = JSON.parse(data)
            console.log(table)
            if (props.table.table_id == table.id) {
                await updateTableInfo(props.table._id, table.tableName, props.table.table_id);
                game.emit[SocketEmit.GetTables]();
            }

        }
        socket.on(SocketOn.TableUpdated, handleTableUpdated);
        return () => {
            socket.off(SocketOn.TableUpdated, handleTableUpdated);
        };
    }, [])

    return (
        <StyledCardContainer className={props.style == "card" ? "card" : "list"}>
            <StyledCardImage src={process.env.REACT_APP_API_ENDPOINT + "/" + props.table.avatar} alt="banner image" crossOrigin="anonymous" />
            {
                !props.table.isPublic && (
                    <StyledRibbon>Private</StyledRibbon>
                )
            }
            {(playerContext?.role == 1 || props.table.created_by === playerContext?.playerId) && (
                <>
                    <StyledEditImage
                        src={editTable ? SubmitIcon : EditIcon}
                        alt="Edit"
                        onClick={handleEditTable}
                    />
                    <StyledRemoveImage
                        src={RemoveIcon}
                        alt="Remove"
                        onClick={handleRemoveTable}
                    />
                    {editTable && (
                        <StyledCloseImage
                            src={CloseIcon}
                            alt="Close"
                            onClick={handleCloseEditTable}
                        />
                    )}
                </>
            )}
            <StyledCardWrapper>
                <StyledCardInfoColumn>
                    {
                        editTable ? (
                            <>
                                <Input width='100%' value={updateTableName} event={handleSetTableName} />
                            </>
                        ) : (
                            <h3 style={{ fontSize: '20px', color: 'white', fontWeight: '400' }}>{props.table.table_name}</h3>
                        )
                    }
                    <div style={{ position: 'relative', height: '30px' }}>
                        {
                            props.table.allPlayers?.filter((a: any) => a.parentPlayer == null).map((player, index) => (
                                <StyledPlayerImage key={index} src={player["avatar"] == '' ? Profiel1 : process.env.REACT_APP_API_ENDPOINT + player["avatar"]} alt="profile1" style={{ right: `${20 * index}px`, zIndex: 1 }} crossOrigin="anonymous" />
                            ))
                        }
                    </div>
                </StyledCardInfoColumn>
                <StyledCardInfoColumn>
                    <div>
                        <h5 style={{ margin: 0, color: 'white', fontWeight: 400, fontSize: '10px', opacity: '0.5' }}>Players</h5>
                        <h5 style={{ margin: 0, color: 'white', fontWeight: 400, fontSize: '12px' }}>{props.table.allPlayers?.filter((a: any) => a.parentPlayer == null).length}/5</h5>
                    </div>
                    <StyledButtonWrapper>
                        {/* <Button padding='15px' textSize='12px' text='watch' image={null} size='small' event={handleWatchTable} /> */}
                        {
                            playerContext?.wallet.connected ? (

                                <Button padding='15px' textSize='12px' text={playerContext?.tokenBalance <= 0 ? "Add fund" : "Join"} image={null} size='small' event={handleJoinTable} />
                            )
                                :
                                (
                                    <Button padding='15px' textSize='12px' text='Link Wallet' image={null} size='small' event={playerContext?.handleConnectWallet} />
                                )
                        }
                    </StyledButtonWrapper>
                </StyledCardInfoColumn>
            </StyledCardWrapper>
        </StyledCardContainer>
    );
}

export default TableCard;
